let env = {};

//env.baseURL = 'http://localhost:8000/api/v1/';
//env.normalURL = 'http://localhost:8000/';

env.baseURL = 'https://api-dimrj.it4d.com.br/api/v1/';
env.normalURL = 'https://api-dimrj.it4d.com.br/';

env.semanalURL = 'https://chronosapi.it4d.com.br/';
env.database = 'CRSAMU_RJ_Rio';

export default env